import { createFileRoute } from "@tanstack/react-router";
import { Home } from "lucide-react";

import { OverviewScoreCards } from "@/components/paid-media/overview/overview-score-cards";
import { TrendsChart } from "@/components/paid-media/overview/trends";
import { KeyInsights } from "@/components/paid-media/overview/key-insights";
import { PaidMediaOverviewV2Page } from "@/components/paid-media/overview-v2/overview-v2-page";
import { PageHeader } from "@/components/layout/heading";
import { useSession } from "@/hooks/use-session";
import { FeatureFlags, isFeatureEnabled } from "@/config/flags";

export const Route = createFileRoute("/dashboard/paid-media/_layout/overview")({
  component: Overview,
});

export function Overview() {
  const session = useSession();
  const companyName = session.profile.company?.company_name;

  // Flip `FeatureFlags.PaidMedia.OverviewV2` to `["*"]` (or paste org UUIDs)
  // to roll out the new Paid Media Overview without changing any URLs.
  if (isFeatureEnabled(FeatureFlags.PaidMedia.OverviewV2, session.organization.id)) {
    return <PaidMediaOverviewV2Page />;
  }

  return (
    <section className="w-full space-y-6">
      <PageHeader title={
        <div className="flex items-center gap-2">
          <Home className="size-5 text-muted-foreground" strokeWidth={2.5} />
           Overview - {companyName ? `${companyName}` : ""}
        </div>
      } />
      <OverviewScoreCards />
      <TrendsChart />
      <KeyInsights />
    </section>
  );
}
